import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {getOrderTypeAntalByAfid,setofUpdatedashboardOrderTV} from 'actions'
import {isEmpty} from 'lodash'
import { withStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

let id = 0;
function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardOrderTY} = accountsData
      const { OrderTypeAntal,DashboardOrderFilterOption} = DashBoard;
      return {
          authUser,OrderTypeAntal,DashboardOrderFilterOption,updatedashboardOrderTY
      };
  }
function createData(type, value, ) {
    id += 1;
    return { id, type, value };
}
function mapDispatchToProps(dispatch) {
    return {
        getOrderTypeAntalByAfid: (Afid,userid,FilterOption) => dispatch(getOrderTypeAntalByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardOrderTV: () => dispatch(setofUpdatedashboardOrderTV()),
        dispatch
    };
}
const useStyles = theme => ({
    root: {
        '&::-webkit-scrollbar': {
            width: '5px'
          },
           
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
           
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
          }
     },
});

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#12585E',
        // backgroundColor: '#14484D',
      },
    },
}))(TableRow);
const data = [
        createData("Telefoni", "38"),
        createData("Bredband", "25"),
        createData("IT", "15"),
        createData("Växel", "9"),
        createData("Övrigt", "2"),
    ];
class ExtraLargeType extends Component {
    state={
        OrderTypeAntal:[],
        DashboardOrderFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getOrderTypeAntalByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
        .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
        () => {
            if(this.state.done === true){            
                this.setState({done: false}) 
          const Afid = this.props.Afid;
          
          this.props.getOrderTypeAntalByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
          .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
    }
        },
        180000
    );
       
    }
    componentWillUnmount() {
      clearInterval(this.intervalID);
      this.intervalID= null
    }  
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid
        if(parseInt(this.props.updatedashboardOrderTY) === 1){
            this.props.getOrderTypeAntalByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
          .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
            this.props.setofUpdatedashboardOrderTV()
        }
     /*
        if(this.props.DashboardOrderFilterOption !== this.state.DashboardOrderFilterOption)
        {
             
            const Afid = this.props.Afid;
            this.props.getOrderTypeAntalByAfid(Afid,undefined,this.state.DashboardOrderFilterOption) 
            .then(() => {
                this.initiateInterval() 
                this.setState({done: true})   
            })
            this.setState({
                DashboardOrderFilterOption:this.props.DashboardOrderFilterOption 
            }) 
        }
        */
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root} style={{ width: '90%',overflowY: "auto",height: this.props.heightValue > 1 ?  this.props.heightValue : 210 }}>
                                {
 this.state.done === false?  
 <>
 <div className="row mx-1">
     <div className="col-12 row mx-1">
         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
     </div>
     <div className="col-12 row mx-1">
         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
     </div>
     <div className="col-12 row mx-1">
         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
     </div>
 </div>
 </>
 :
            <Table>
                <TableBody>
                {
                    isEmpty(this.props.OrderTypeAntal)?"":
                    this.props.OrderTypeAntal.map(n => {
                        return (
                            <StyledTableRow key={n.id}>
                                <TableCell align="left" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', fontSize: 14, borderBottom: '1px solid transparent' }}>{n.OrderType}</TableCell>
                                <TableCell align="right" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', fontSize: 14, borderBottom: '1px solid transparent' }}>{n.total}st</TableCell>
                            </StyledTableRow>
                        );
                    })}

                </TableBody>
            </Table>
    }
        </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(withStyles(useStyles)(ExtraLargeType));

